import { Text, Group } from "@mantine/core";
import type { CSSObject as CSS } from "@mantine/emotion";
import { FC } from "react";

import { isValidNumberWithDecimals } from "../../regex/InputRegex";
import { useStyles } from "./NumberInput.styles";

type Props = {
  labelText: string;
  id?: string;
  placeHolder?: string;
  onChange?: CallableFunction;
  onBlur?: CallableFunction;
  style?: CSS;
  isErrored?: string;
  value: number | string | null;
  min?: number;
  decimalPlaces?: number;
};

const NumberInputGroup: FC<Props> = ({
  labelText,
  id,
  placeHolder,
  onChange,
  onBlur,
  isErrored,
  value,
  min,
  decimalPlaces = 2,
}) => {
  const { classes } = useStyles();

  const OnChange = (event: any) => {
    const newValue = event.target.value;
    const validationRegex = isValidNumberWithDecimals(decimalPlaces);

    if (validationRegex.test(newValue)) {
      // Convert input value to number and pass it to onChange
      const parsedValue = parseFloat(newValue);
      onChange?.(parsedValue);
    }
    // onChange ? onChange(newValue) : 0;
  };

  const OnBlur = (event: any) => {
    const currentValue = event.target.value;

    if (onBlur) {
      onBlur(currentValue);
    }
  };
  return (
    <div className={classes.mainContainer}>
      <Group justify="flex-start" mb={5}>
        <Text className={classes.text} component="label" htmlFor={id} size="sm">
          {labelText}
        </Text>
      </Group>
      <input
        type="number"
        id={id}
        placeholder={placeHolder}
        className={classes.inputField}
        value={value === null ? undefined : value}
        onChange={OnChange}
        onBlur={OnBlur}
        min={min}
      />
      {isErrored && <div className={classes.errorMessage}>{isErrored}</div>}
    </div>
  );
};

export default NumberInputGroup;
